import React, { useState } from "react";
import {
  List,
  useTable,
  EditButton,
  DeleteButton,
  TableColumnType,
  Button,
  Table,
  SaveButton,
  Form,
  Input,
} from "@pankod/refine-antd";
import { useExport } from "@pankod/refine-core";
import { ISearch } from "type";

export const BotAffiliateList = () => {
  const [query, setQuery] = useState("");
  const { tableProps, searchFormProps } = useTable({
    queryOptions: { retry: false },
    onSearch: (values: ISearch) => {
      return [
        {
          field: "q",
          operator: "contains",
          value: values.q ? values.q : null,
        },
      ];
    },
  });
  const { triggerExport } = useExport({
    filters: [
      {
        field: "q",
        operator: "contains",
        value: query,
      },
    ],
  });
  const columns = React.useMemo<TableColumnType<any>[]>(
    () => [
      {
        dataIndex: "bot_affiliate_id",
        title: "Bot Affiliate Id",
        type: "number",
        width: 50,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
        fixed: "left",
      },
      {
        dataIndex: "bot_exchange_id",
        title: "Bot Exchange Id",
        width: 200,
        type: "number",
      },
      {
        dataIndex: "credential_account_id",
        title: "Credential Account Id",
        type: "number",
        width: 200,
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "created_at",
        title: "Created At",
        width: 200,
      },
      {
        dataIndex: "updated_at",
        title: "Updated At",
        width: 200,
      },
      {
        dataIndex: "actions",
        title: "Actions",
        render: (_, record) => {
          return (
            <>
              <EditButton hideText recordItemId={record.bot_affiliate_id} />
              <DeleteButton hideText recordItemId={record.bot_affiliate_id} />
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        width: 80,
        fixed:"right"
      },
    ],
    []
  );

  return (
    <List
      headerButtons={({ defaultButtons }) => (
        <>
          <Form {...searchFormProps} layout="inline">
            <Form.Item name="q">
              <Input
                placeholder="Search by ..."
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
            </Form.Item>
            <SaveButton type="default" onClick={searchFormProps.form?.submit}>
              SEARCH
            </SaveButton>
          </Form>
          {defaultButtons}
          <Button type="primary" onClick={triggerExport}>
            EXPORT
          </Button>
        </>
      )}
    >
      <Table
        {...tableProps}
        bordered={true}
        rowKey="bot_affiliate_id"
        columns={columns}
        scroll={{ x: 1500 }}
        size="middle"
        pagination={{
          ...tableProps.pagination,
          position: ["bottomRight"],
          size: "default",
        }}
      ></Table>
    </List>
  );
};
